import { useDisclosure } from '@/hooks';
import { Button } from 'antd';
import { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import ComplementWhatsappModal from './ComplementWhatsappModal';
import { Group } from '@/components/_common';

const ComplementWhatsappButton: React.FC = () => {
  const {
    workorder: { data },
  } = useWorkorderDetailContext();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [modalOpened, modalAction] = useDisclosure(false, {
    onClose: () => setPhoneNumber(undefined),
  });

  return (
    <>
      <Button block onClick={modalAction.open}>
        <Group align="center" position="center">
          <span>
            <FaWhatsapp size={15} />
          </span>

          <span>WhatsApp</span>
        </Group>
      </Button>

      <ComplementWhatsappModal
        customerId={data?.customer?.id}
        open={modalOpened}
        onCancel={modalAction.close}
        phoneNumber={phoneNumber}
      />
    </>
  );
};

export default ComplementWhatsappButton;
